import mitt from 'mitt';
import Events from './events';

const emitter = mitt<Events>();

export function useEmitter() {
  return emitter;
}
